import React from 'react';
import ChatStatusBadge from './ChatStatusBadge';

const ChatHeader = ({ conversation: conv, role, hasAgents = false, onAssign, onClose, isClosed, onBack }) => {
    /* Only offer Assign when the role may assign AND there is at least one agent to assign to. */
    const canAssign = ['admin', 'subadmin', 'supervisor'].includes(role) && hasAgents;
    const name = conv.customerName || conv.customerMobile || 'Customer';

    return (
        <div className="chat-header">
            <div className="chat-header-left">
                {onBack && (
                    <button className="chat-back-btn" onClick={onBack} title="Back to list">
                        ←
                    </button>
                )}
                <div className="chat-header-avatar">
                    {name[0]?.toUpperCase() || 'C'}
                </div>
                <div className="chat-header-info">
                    <div className="chat-header-name">{name}</div>
                    <div className="chat-header-sub">
                        {conv.customerMobile && <span>📱 {conv.customerMobile}</span>}
                        &nbsp;<ChatStatusBadge status={conv.status} />
                    </div>
                    {conv.assignedAgentName && (
                        <div className="chat-header-agent">
                            👤 Assigned: <strong>{conv.assignedAgentName}</strong>
                        </div>
                    )}
                </div>
            </div>

            <div className="chat-header-actions">
                {canAssign && !isClosed && (
                    <button className="chat-action-btn chat-action-btn--assign" onClick={onAssign}>
                        👤 {conv.assignedAgentId ? 'Reassign' : 'Assign Agent'}
                    </button>
                )}
            </div>
        </div>
    );
};

export default ChatHeader;
